import { defineComponent as n, ref as c, reactive as m, computed as t, provide as f, openBlock as d, createElementBlock as p, normalizeClass as u, renderSlot as _ } from "vue";
import { ListSymbol as y, getListStyleClasses as v } from "./novoui-vuejs57.js";
const k = /* @__PURE__ */ n({
  __name: "NList",
  props: {
    multiselect: { default: "" },
    padding: { default: "small" },
    size: { default: void 0 },
    emitInstead: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 }
  },
  emits: ["selected"],
  setup(l, { expose: o, emit: z }) {
    const s = c();
    o({ listRef: s });
    const e = l, a = m({
      multiselect: t(() => e.multiselect),
      size: t(() => e.size || void 0)
    });
    f(y, a);
    const i = t(() => v(e));
    return (r, B) => (d(), p("ul", {
      class: u(i.value),
      ref_key: "listRef",
      ref: s
    }, [
      _(r.$slots, "default")
    ], 2));
  }
});
export {
  k as default
};
